import { useQuery, gql } from '@apollo/client'
import { User } from '../../types'

type Data = {
  user: User
}
type Vars = {
  id: string
}

const doc = gql`
  query User($id: String!) {
    user(id: $id) {
      id
      name
      phoneNumber
      smsEnabled
      notify
    }
  }
`

const useUser = (id: string) => {
  const { loading, error, data, refetch } = useQuery<Data, Vars>(doc, {
    variables: { id },
  })
  return { loading, error, data, refetch }
}

useUser.Query = doc
export default useUser
